var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 54.849,
    viewBox: "0 0 65 54.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "list-check-solid_1_",
    "data-name": "list-check-solid (1)",
    d: "M19.264,32.714a3.038,3.038,0,0,1,.228,4.3l-9.14,10.155a3,3,0,0,1-2.183,1,3.115,3.115,0,0,1-2.234-.889L.845,42.209a3.073,3.073,0,0,1,0-4.316,3.034,3.034,0,0,1,4.3,0L7.954,40.7l6.994-7.769a3.038,3.038,0,0,1,4.3-.228Zm0,20.311a3.038,3.038,0,0,1,.228,4.3l-9.14,10.155a3,3,0,0,1-2.183,1A3.115,3.115,0,0,1,5.935,67.6L.845,62.52a3.043,3.043,0,0,1,4.3-4.3l2.805,2.805,6.994-7.769a3.038,3.038,0,0,1,4.3-.228Zm9.127-12.973a4.058,4.058,0,0,1,4.062-4.062H60.888a4.062,4.062,0,1,1,0,8.124H32.453A4.058,4.058,0,0,1,28.391,40.051Zm0,20.311A4.058,4.058,0,0,1,32.453,56.3H60.888a4.062,4.062,0,1,1,0,8.124H32.453A4.058,4.058,0,0,1,28.391,60.362ZM20.267,80.672a4.058,4.058,0,0,1,4.062-4.062H60.888a4.062,4.062,0,0,1,0,8.124H24.329A4.058,4.058,0,0,1,20.267,80.672ZM6.05,74.579A6.093,6.093,0,1,1-.044,80.672,6.093,6.093,0,0,1,6.05,74.579Z",
    transform: "translate(0.05 -31.916)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistWhiteIcon);
export default __webpack_public_path__ + "static/media/checklist-white-icon.7ad1e2fc7e2943463c810af24dac86ec.svg";
export { ForwardRef as ReactComponent };